import { render, staticRenderFns } from "./institution.vue?vue&type=template&id=15bd039e&scoped=true"
import script from "./institution.vue?vue&type=script&lang=js"
export * from "./institution.vue?vue&type=script&lang=js"
import style0 from "./institution.vue?vue&type=style&index=0&id=15bd039e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd039e",
  null
  
)

export default component.exports